export const PaymentErrors = {
  '1001': 'This transaction has been approved.',
  '1002': 'This transaction has been declined.',
  '1003': 'This transaction has been declined.',
  '1004': 'This transaction has been declined.',
  '1005': 'A valid amount is required.',
  '1006': 'The credit card number is invalid.',
  '1007': 'The credit card expiration date is invalid.',
  '1008': 'The credit card has expired.',
  '1009': 'The ABA code is invalid.',
  '1010': 'The account number is invalid.',
  '1011': 'A duplicate transaction has been submitted.',
  '1012': 'An authorization code is required but not present.',
  '1013': 'The merchant API Login ID is invalid or the account is inactive.',
  '1014': 'The Referrer or Relay Response URL is invalid.',
  '1015': 'The transaction ID is invalid.',
  '1016': 'The transaction was not found.',
  '1017': 'The merchant does not accept this type of credit card.',
  '1018': 'ACH transactions are not accepted by this merchant.',
  '1019': 'An error occurred during processing. Please try again in 5 minutes.',
  '1020': 'An error occurred during processing. Please try again in 5 minutes.',
  '1021': 'An error occurred during processing. Please try again in 5 minutes.',
  '1022': 'An error occurred during processing. Please try again in 5 minutes.',
  '1023': 'An error occurred during processing. Please try again in 5 minutes.',
  '1024': 'The Nova Bank Number or Terminal ID is incorrect. Call Merchant Service Provider.',
  '1025': 'An error occurred during processing. Please try again in 5 minutes.',
  '1026': 'An error occurred during processing. Please try again in 5 minutes.',
  '1027':
    'The transaction resulted in an AVS mismatch. The address provided does not match billing address of cardholder.',
  '1028': 'The merchant does not accept this type of credit card.',
  '1029': 'The Paymentech identification numbers are incorrect. Call Merchant Service Provider.',
  '1030': 'The configuration with the processor is invalid. Call Merchant Service Provider.',
  '1031': 'The FDC Merchant ID or Terminal ID is incorrect. Call Merchant Service Provider.',
  '1032': 'This reason code is reserved or not applicable to this API.',
  '1033': 'FIELD cannot be left blank.',
  '1034': 'The VITAL identification numbers are incorrect. Call Merchant Service Provider.',
  '1035': 'An error occurred during processing. Call Merchant Service Provider.',
  '1036': 'The authorization was approved, but settlement failed.',
  '1037': 'The credit card number is invalid.',
  '1038':
    'The Global Payment System identification numbers are incorrect. Call Merchant Service Provider.',
  '1039': 'This transaction must be encrypted.',
  '1040': 'This transaction has been declined.',
  '1041':
    'The merchant was incorrectly set up at the processor. Call your Merchant Service Provider.',
  '1042': 'This transaction has been declined.',
  '1043': 'This transaction has been declined.',
  '1044': 'Your session has expired or does not exist. You must log in to continue working.',
  '1045':
    'The amount requested for settlement may not be greater than the original amount authorized.',
  '1046': 'This processor does not accept partial reversals.',
  '1047': 'A transaction amount greater than $[amount] will not be accepted.',
  '1048': 'This transaction is awaiting settlement and cannot be refunded.',
  '1049':
    'The sum of all credits against this transaction is greater than the original transaction amount.',
  '1050':
    'The transaction was authorized, but the client could not be notified; the transaction will not be settled.',
  '1051': 'The transaction type was invalid for ACH transactions.',
  '1052': 'The referenced transaction does not meet the criteria for issuing a credit.',
  '1053':
    'The sum of credits against the referenced transaction would exceed the original debit amount.',
  '1054': 'This merchant accepts ACH transactions only; no credit card transactions are accepted.',
  '1055': 'An error occurred in processing. Please try again in 5 minutes.',
  '1056': 'An error occurred in processing. Please try again in 5 minutes.',
  '1057': 'An error occurred in processing. Please try again in 5 minutes.',
  '1058': 'An error occurred in processing. Please try again in 5 minutes.',
  '1059': 'An error occurred in processing. Please try again in 5 minutes.',
  '1060': 'An error occurred in processing. Please try again in 5 minutes.',
  '1061': 'An error occurred in processing. Please try again in 5 minutes.',
  '1062': 'This transaction has been declined.',
  '1063': 'This transaction cannot be accepted for processing.',
  '1064': 'The version parameter is invalid.',
  '1065': 'The transaction type is invalid.',
  '1066': 'The transaction method is invalid.',
  '1067': 'The bank account type is invalid.',
  '1068': 'The authorization code is invalid.',
  '1069': 'The driver’s license date of birth is invalid.',
  '1070': 'The duty amount is invalid.',
  '1071': 'The freight amount is invalid.',
  '1072': 'The tax amount is invalid.',
  '1073': 'The SSN or tax ID is invalid.',
  '1074': 'The Card Code (CVV2/CVC2/CID) is invalid.',
  '1075': 'The driver’s license number is invalid.',
  '1076': 'The driver’s license state is invalid.',
  '1077': 'The requested form type is invalid.',
  '1078': 'Scripts are only supported in version 2.5.',
  '1079': 'The requested script is either invalid or no longer supported.',
  '1080': 'This reason code is reserved or not applicable to this API.',
  '1081': 'This reason code is reserved or not applicable to this API.',
  '1082': 'This reason code is reserved or not applicable to this API.',
  '1083': 'This reason code is reserved or not applicable to this API.',
  '1084': 'This reason code is reserved or not applicable to this API.',
  '1085': 'This reason code is reserved or not applicable to this API.',
  '1086': 'This reason code is reserved or not applicable to this API.',
  '1087': 'Version 2.5 is no longer supported.',
  '1088': 'The gateway no longer supports the requested method of integration.',
  '1089': 'This transaction cannot be accepted.',
  '1090': 'This transaction cannot be accepted.',
  '1091': 'This transaction cannot be accepted.',
  '1092': 'The eCheck.Net type is invalid.',
  '1093':
    'The given name on the account and/or the account type does not match the actual account.',
  '1094': 'This request cannot be accepted.',
  '1095': 'This transaction cannot be accepted.',
  '1096': 'This transaction is currently under review.',
  '1097': 'This transaction is currently under review.',
  '1098': 'This transaction is currently under review.',
  '1099': 'This transaction is currently under review.',
  '1100': 'This transaction is currently under review.',
  '1101': 'This transaction is currently under review.',
  '1102': 'This transaction is currently under review.',
  '1103': 'The authentication indicator is invalid.',
  '1104': 'The cardholder authentication value is invalid.',
  '1105':
    'The combination of authentication indicator and cardholder authentication value is invalid.',
  '1106': 'Transactions having cardholder authentication values cannot be marked as recurring.',
  '1107': 'An error occurred during processing. Please try again.',
  '1108': 'An error occurred during processing. Please try again.',
  '1109': 'An error occurred during processing. Please try again.',
  '1110': 'This account has not been given the permission(s) required for this request.',
  '1111':
    'The transaction resulted in an AVS mismatch. The address provided does not match billing address of cardholder.',
  '1112': 'This transaction cannot be processed.',
  '1113': 'This payment gateway account has been closed.',
  '1114': 'This transaction cannot be accepted at this time.',
  '1115': 'This transaction cannot be accepted at this time.',
  '1116': 'This transaction has been declined.',
  '1117': 'This transaction has been declined.',
  '1118':
    'The transaction was authorized, but the client could not be notified; the transaction will not be settled.',
  '1119': 'This transaction has been declined.',
  '1120': 'An error occurred during processing. Please contact the merchant.',
  '1121': 'An error occurred during processing. Please contact the merchant.',
  '1122': 'An error occurred during processing. Please contact the merchant.',
  '1123': 'An error occurred during processing. Please contact the merchant.',
  '1124': 'The transaction type is invalid. Please contact the merchant.',
  '1125': 'The processor does not allow voiding of credits.',
  '1126': 'An error occurred during processing. Please try again.',
  '1127': 'An error occurred during processing. Please try again.',
  '1128': 'This reason code is reserved or not applicable to this API.',
  '1129': 'The transaction is currently under review.',
  '1130': 'This transaction has been declined.',
  '1131': 'This transaction has been declined.',
  '1132': 'This transaction has been declined.',
  '1133': 'This transaction has been declined.',
  '1134': 'This transaction has been declined.',
  '1135': 'This transaction has been declined.',
  '1136': 'This transaction has been declined.',
  '1137': 'This transaction has been declined.',
  '1138': 'This transaction has been declined.',
  '1139': 'This transaction has been declined.',
  '1140': 'This transaction has been declined.',
  '1141': 'This transaction has been declined.',
  '1142': 'This transaction has been declined.',
  '1143': 'This transaction has been declined.',
  '1144': 'This transaction has been declined.',
  '1145': 'This transaction has been declined.',
  '1146': 'This transaction has been declined.',
  '1147': 'This transaction has been declined.',
  '1148': 'This transaction has been declined.',
  '1149': 'This transaction has been declined.',
  '1150': 'This transaction has been declined.',
  '1151': 'This transaction has been declined.',
  '1152': 'This transaction has been declined.',
  '1153': 'This transaction has been declined.',
  '1154': 'This transaction has been declined.',
  '1155': 'Recurring billing is not allowed for this eCheck.Net type.',
  '1156': 'This eCheck.Net type is not allowed for this Bank Account Type.',
  '1157': 'This eCheck.Net type is not allowed when using the payment gateway hosted payment form.',
  '1158': 'This eCheck.Net type is not allowed.',
  '1159': 'This eCheck.Net type is not allowed.',
  '1160': 'The check number is invalid.',
  '1161': 'This transaction has been declined.',
  '1162': 'This transaction has been declined.',
  '1163': 'Your order has been received. Thank you for your business!',
  '1164': 'Your order has been received. Thank you for your business!',
  '1165': 'Your transaction has been declined.',
  '1166': 'An error occurred during processing. Please try again.',
  '1167': 'The line item [item number] is invalid.',
  '1168':
    'The number of line items submitted is not allowed. A maximum of 30 line items can be submitted.',
  '1169':
    'Merchant is not registered as a Cardholder Authentication participant. This transaction cannot be accepted.',
  '1170': 'This processor does not accept zero dollar authorization for this card type.',
  '1171': 'One or more required AVS values for zero dollar authorization were not submitted.',
  '1172':
    'The amount of this request was only partially approved on the given prepaid card. Additional payments are required to complete the balance of this transaction.',
  '1173': 'The specified SplitTenderId is not valid.',
  '1174':
    'A Transaction ID and a Split Tender ID cannot both be used in a single transaction request.',
  '1175': 'The device ID is invalid.',
  '1176': 'The device batch ID is invalid.',
  '1177': 'The reversal flag is invalid.',
  '1178': 'The device batch is full. Please close the batch.',
  '1179': 'The original transaction is in a closed batch.',
  '1180': 'The merchant is configured for auto-close.',
  '1181': 'The batch is already closed.',
  '1182': 'The reversal was processed successfully.',
  '1183': 'Original transaction for reversal not found.',
  '1184': 'The device has been disabled.',
  '1185': 'This transaction has already been voided.',
  '1186': 'This transaction has already been captured',
  '1187': 'The credit card number is invalid.',
  '1188': 'The credit card expiration date is invalid.',
  '1189': 'The credit card has expired.',
  '1190': 'A duplicate transaction has been submitted.',
  '1191': 'The transaction cannot be found.',
  '1325': 'Decline',
  '1326': 'Expired Card',
  '1327': 'PIN Retries Exceeded',
  '1328': 'No Sharing',
  '1329': 'No Security Module',
  '1330': 'Invalid Transaction',
  '1331': 'No Support',
  '1332': 'Lost Or Stolen Card',
  '1333': 'Invalid Status',
  '1334': 'Restricted Card',
  '1335': 'No Chequing Account',
  '1336': 'No PBF',
  '1337': 'PBF Update Error',
  '1338': 'Invalid Authorization Type',
  '1339': 'Bad TRACK 2',
  '1340': 'Adjustment Not Allowed',
  '1341': 'Invalid Credit Card Advance Increment',
  '1342': 'Invalid Transaction Date',
  '1343': 'PTLF Error',
  '1344': 'Bad Message Error',
  '1345': 'No IDF',
  '1346': 'Invalid Route Authorization',
  '1347': 'Card On National NEG File',
  '1348': 'Invalid Route Service',
  '1349': 'Unable To Authorize',
  '1350': 'Invalid PAN Length',
  '1351': 'Low Funds',
  '1352': 'Pre-Auth Full',
  '1353': 'Duplicate Transaction',
  '1354': 'Maximum Online Refund Reached',
  '1355': 'Maximum Offline Refund Reached',
  '1356': 'Maximum Credit Per Refund Reached',
  '1357': 'Number Of Times Used Exceeded',
  '1358': 'Maximum Refund Credit Reached',
  '1359': 'Duplicate Transaction - Authorization Number Has Already Been Corrected By Host.',
  '1360': 'Inquiry Not Allowed',
  '1361': 'Over Floor Limit',
  '1362': 'Maximum Number Of Refund Credit By Retailer',
  '1363': 'Place Call',
  '1364': 'CAF Status Inactive Or Closed',
  '1365': 'Referral File Full',
  '1366': 'NEG File Problem',
  '1367': 'Advance Less Than Minimum',
  '1368': 'Delinquent',
  '1369': 'Over Table Limit',
  '1370': 'Amount Over Maximum',
  '1371': 'PIN Required',
  '1372': 'Mod 10 Check Failure',
  '1373': 'Force Post',
  '1374': 'Bad PBF',
  '1375': 'Unable To Process Transaction - Invalid Request',
  '1376': 'Place Call',
  '1377': 'System Problem ###/',
  '1378': 'NEG File Problem',
  '1379': 'CAF Problem',
  '1380': 'Card Not Supported',
  '1381': 'Amount Over Maximum',
  '1382': 'Over Daily Limit',
  '1383': 'CAF Problem',
  '1384': 'Advance Less Than Minimum',
  '1385': 'Number Of Times Used Exceeded',
  '1386': 'Delinquent',
  '1387': 'Over Table Limit',
  '1388': 'Time-out',
  '1389': 'PTLF Error',
  '1390': 'Administration File Problem',
  '1391': 'Unable To Validate PIN: Security Module Down',
  '1392': 'Merchant Not On File',
  '1393': 'Invalid Account',
  '1394': 'Incorrect PIN',
  '1395': 'Advance Less Than Minimum',
  '1396': 'Administrative Card Needed',
  '1397': 'Amount Over Maximum',
  '1398': 'Invalid Advance Amount',
  '1399': 'CAF Not Found',
  '1400': 'Invalid Transaction Date',
  '1401': 'Invalid Expiration Date',
  '1402': 'Invalid Transaction Code',
  '1403': 'PIN Key Sync Error',
  '1404': 'Destination Not Available',
  '1405': 'Error On Cash Amount',
  '1406': 'Debit Not Supported',
  '1407': 'AMEX - Denial 12',
  '1408': 'AMEX - Invalid Merchant',
  '1409': 'AMEX - Account Error',
  '1410': 'AMEX - Expired Card',
  '1411': 'AMEX - Call Amex',
  '1412': 'AMEX - Call 03',
  '1413': 'AMEX - System Down',
  '1414': 'AMEX - Call 05',
  '1415': 'AMEX - Declined, Call',
  '1416': 'AMEX - Declined, Call',
  '1417': 'AMEX - Service Error',
  '1418': 'AMEX - Call Amex',
  '1419': 'AMEX - Amount Error',
  '1420': 'CREDIT CARD - Invalid Expiratio Date',
  '1421': 'CREDIT CARD - Invalid Transaction, Rejected',
  '1422': 'CREDIT CARD - Refer Call',
  '1423': 'CREDIT CARD - Decline, Pick Up Card, Call',
  '1424': 'CREDIT CARD - Decline, Pick Up Card',
  '1425': 'CREDIT CARD - Decline, Pick Up Card',
  '1426': 'CREDIT CARD - Decline',
  '1427': 'CREDIT CARD - Expired Card',
  '1428': 'CREDIT CARD - Refer',
  '1429': 'CREDIT CARD - Expired Card ­ Refer',
  '1430': 'CREDIT CARD - Not Authorized',
  '1431': 'CREDIT CARD - CVV Cryptographic Error',
  '1432': 'CREDIT CARD - Invalid CVV',
  '1433': 'CREDIT CARD - Invalid CVV',
  '1434': 'CREDIT CARD - Invalid CVV',
  '1435': 'Bad Format',
  '1436': 'Bad Data',
  '1437': 'Invalid Clerk ID',
  '1438': 'Bad Close',
  '1439': 'System Timeout No response from Moneris Host',
  '1440': 'System Error',
  '1441': 'Bad Response Length',
  '1442': 'Invalid PIN Block',
  '1443': 'PIN Length Error',
  '1444': 'Final Response Packet of a Multi Packet Transaction',
  '1445': 'Continuation Response Packet of Multi-Packet Transaction',
  '1446': 'Download Aborted',
  '1447': 'MAC Key Sync Error',
  '1448': 'Bad MAC Value',
  '1449': 'Bad Sequence number ­ Terminal must handle this internally ­ Resend transaction',
  '1450': 'Capture - PIN Tries Exceeded',
  '1451': 'Capture - Expired Card',
  '1452': 'Capture - NEG Capture',
  '1453': 'Capture - CAF Status 3',
  '1454': 'Capture - Advance less than Minimum',
  '1455': 'Capture - Num Times Used',
  '1456': 'Capture - Delinquent',
  '1457': 'Capture - Over Limit Table',
  '1458': 'Capture - Amount Over Maximum',
  '1459': 'Capture - Capture',
  '1460': 'Initialization Failure - No Match on Merchant ID',
  '1461': 'Initialization Failure - No Match on PINPad',
  '1462': 'Initialization Failure - No Match on Printer ID',
  '1463': 'Initialization Failure - No Match on Poll Code',
  '1464': 'Initialization Failure - No Match on Concentrator ID',
  '1465': 'Invalid Software Version Number',
  '1466': 'Duplicate Terminal Name',
  '1467': 'Terminal/Clerk Table Full',
  '1468': 'Clerk Totals Unavailable: selected Clerk IDs do not exist or have zero totals.',
  '1469': 'MAC Error on Transaction 95',
  '1470': 'PWS_UNKNOWN_ERROR',
  '1471': 'PWS_NETWORK_ERROR',
  '1472': 'PWS_DB_ERROR',
  '1473': 'DTD Error',
  '1474': 'Cannot Get to Authorizer Service',
  '1475': 'Industry Type is Currently Not Supported for Merchant and BIN',
  '1476': 'PWS_DB_EXCEPTION_ERROR',
  '1477': 'PWS_ERROR_FAILED_TO_CONNECT',
  '1478': 'PWS_NW_OPEN_ERROR',
  '1479': 'PWS_NW_READ_ERROR',
  '1480': 'PWS_ERROR_BAD_REVERSAL_AMOUNT',
  '1481': 'PWS_ERROR_BAD_REQUEST_AMOUNT',
  '1482': 'PWS_ERROR_ALREADY_CAPTURED',
  '1483': 'PWS_ERROR_INVALID_ACTION',
  '1484': 'PWS_ERROR_MISSING_TRANSACTION_REFERENCE_INDEX',
  '1485': 'PWS_ERROR_SPLIT_AUTH_NOT_ALLOWED_ALREADY_MARKED',
  '1486': 'PWS_DID_NOT_ALLOW_A_CAPTURE_REQUEST_BECAUSE_THE_ORIGINAL_AUTH_WAS_NOT_SUCCESSFUL',
  '1487': 'The amount requested cannot be zero',
  '1488': 'This industry type does not allow a capture greater than the value of the auth',
  '1489':
    'Re-Auth failed. This error is returned when a re-auth is attempted behind-the-scenes by the Gateway (usually in the case of a split transaction) and fails at the host.',
  '1490': 'There is nothing to capture',
  '1491': 'PWS_MANDATORY_FIELDS_ERROR',
  '1492': 'FE_NETWORK_ERROR (cannot connect to eHost)',
  '1493': 'FE_INTERRUPTED_SESSION (i/o problem while connecting to eHost)',
  '1494': 'The Merchant ID/Acquiring BIN ID is invalid or missing. Message rejected',
  '1495':
    'This merchant is not active until … [This error is returned when a Merchant Account has been setup, but with an Activation date in the future of the present date].',
  '1496': 'This merchant is inactive',
  '1497':
    'eHost has received a badly formatted message [This error is returned when required fields are missing]',
  '1498': 'An invalid TID was received [Terminal ID]',
  '1499': 'PWS_ERR_VALIDATION_AMOUNT',
  '1500': 'PWS_ERR_VALIDATION_AVSADDRESS',
  '1501': 'PWS_ERR_VALIDATION_AVSZIPCODE',
  '1502': 'PWS_ERR_VALIDATION_BIN',
  '1503': 'PWS_ERR_VALIDATION_CUSTOMERADDR',
  '1504': 'PWS_ERR_VALIDATION_CUSTOMEREMAIL',
  '1505': 'PWS_ERR_VALIDATION_CUSTOMERNAME',
  '1506': 'PWS_ERR_VALIDATION_CUSTOMERPHONE',
  '1507': 'PWS_ERR_VALIDATION_CVV2',
  '1508': 'PWS_ERR_VALIDATION_ISSUENUM',
  '1509': 'PWS_ERR_VALIDATION_LANGUAGE',
  '1510': 'PWS_ERR_VALIDATION_MERCHANTID',
  '1511': 'PWS_ERR_VALIDATION_ORDERDESCRIPTION',
  '1512': 'PWS_ERR_VALIDATION_ORDERID',
  '1513': 'PWS_ERR_VALIDATION_TAXAMT',
  '1514': 'PWS_ERR_VALIDATION_TAXINCLUDED',
  '1515': 'PWS_ERR_VALIDATION_TERMINALID',
  '1516': 'PWS_ERR_VALIDATION_TRANSDATE',
  '1517': 'PWS_ERR_VALIDATION_TRANSTIME',
  '1518': 'PWS_ERR_VALIDATION_ECOM',
  '1519': 'PWS_ERR_VALIDATION_ACNUMBER',
  '1520': 'PWS_ERR_VALIDATION_PAN_LUHN',
  '1521': 'PWS_ERR_VALIDATION_PAN_LENGTH',
  '1522': 'PWS_ERR_VALIDATION_PAN_RANGE',
  '1523': 'PWS_ERR_VALIDATION_EXP_DATE_FORMAT',
  '1524': 'PWS_ERR_VALIDATION_EXP_DATE_TOO_NEW',
  '1525': 'PWS_ERR_VALIDATION_START_DATE_FORMAT',
  '1526': 'PWS_ERR_VALIDATION_START_DATE_TOO_NEW',
  '1527': 'PWS_ERR_VALIDATION_PAN_FORMAT',
  '1528': 'PWS_ERR_VALIDATION_CURRENCY_FORMAT',
  '1529': 'PWS_ERR_VALIDATION_CURRENCY_UNSUPPORTED',
  '1530': 'PWS_ERR_VALIDATION_CURRENCY_BAD_EXPONENT',
  '1531': 'PWS_ERR_VALIDATION_MERCHANT_UNSUPPORTED',
  '1532': 'PWS_ERR_VALIDATION_BRAND_UNSUPPORTED',
  '1533': 'PWS_ERR_VALIDATION_BRAND_PAN_MISMATCH',
  '1534':
    'The LIDM you supplied # does not match with any existing transaction (Cannot void or Mark a Transaction because the TxRefNum does match a transaction)',
  '1535': 'LOCKED_DOWN (Cannot mark or unmark transaction)',
  '1536': 'Error Validating Amount. Must be Numeric, Equal to Zero or Greater',
  '1537': 'Zero Dollar Auth: ZIP is Mandatory',
  '1538': 'Reversal: Invalid Reversal Indicator [%s]. Must be one of the following values: [YN]',
  '1539': 'Invalid Customer Reference Number From Order Indicator',
  '1540': 'Invalid Customer Reference Number',
  '1541': 'System Failure. Unable To Perform Customer Profile Request at This Time.',
  '1542': 'Invalid Action Indicator',
  '1543': 'Invalid BIN',
  '1544': 'Invalid Merchant ID',
  '1545': 'Invalid Name',
  '1546': 'Invalid Address',
  '1547': 'Invalid Address 2',
  '1548': 'Invalid City',
  '1549': 'Invalid State',
  '1550': 'Invalid ZIP',
  '1551': 'Invalid Email',
  '1552': 'Invalid Phone',
  '1553': 'Invalid Order Description',
  '1554': 'Invalid Amount',
  '1555': 'Invalid Account Type Indicator',
  '1556': 'Invalid Account Number',
  '1557': 'Invalid Account Expire Date',
  '1558': 'Invalid ECP Account DDA',
  '1559': 'Invalid ECP Account Type Indicator',
  '1560': 'Invalid ECP Account Route',
  '1561': 'Invalid ECP Bank Payment Delivery Method',
  '1562': 'Invalid Switch Solo Start Date',
  '1563': 'Invalid Switch Solo Issue Number',
  '1564': 'Unable to Perform Profile Transaction. The Associated Transaction Failed.',
  '1565': 'Invalid Order Override Indicator',
  '1566': 'Merchant-Bin combination is not allowed to perform profile transactions.',
  '1567': 'Merchant-Bin is not active.',
  '1568':
    'Cannot process profile for Cust Ref Num and MID combination. A database error has occurred',
  '1569': 'Cannot process profile. Profile does not exist for Cust Ref Num and MID.',
  '1570': 'Cannot process profile. Profile already exists for Cust Ref Num and MID.',
  '1571': 'Missing Switch Solo Account Information. Either start date or issue number is required.',
  '1572': 'Missing Electronic Check Account Information.',
  '1573': 'Missing Credit Card Account Information.',
  '1574': 'Auto-Gen Cust Ref Num Error.',
  '1575': 'Unable to Determine Profile Action from Auth Request',
  '1576': 'Cannot Create Profile: A Customer Profile Name is Required',
  '1577': 'Invalid Profile Status Requested',
  '1578': 'The Profile’s status prohibits the type of transaction being attempted.',
  '1579': 'Schedule Date – The Future Schedule Date Is Invalid',
  '1580': 'Schedule Date – The Future Schedule Date Is In The Past',
  '1581': 'Message expired during retry',
  '1582': 'Too many transactions to process',
  '1583': 'Request timeout - Please try again',
  '1584': 'Invalid MIME header - Merchant ID in MIME does not match XML message',
  '1585': 'Invalid MIME header- Trace number must be between 1 and 9999999999999999',
  '1586': 'The retry request did not match the original request for this trace number',
  '1587': 'Security Information is Missing',
  '1588': 'Security Information - agent/chain/merchant is missing',
  '1589': 'Invalid AVS Country Code [%s]. Supported values are [CA], [GB], [UK], or [US]',
  '1590': 'Invalid Date Length: Format is YYYYMM',
  '1591': 'Invalid Date Length: Format is YYYYMM',
  '1592': 'Soft Desc: Merchant not activated for soft descriptors',
  '1593': 'Soft Desc: Merchant Name is required if soft descriptor data is sent',
  '1594': 'Soft Desc: Merchant Name exceeds max length of [%s] for %s transactions',
  '1595': 'Soft Desc: [%s] cannot contain leading spaces',
  '1596': 'Soft Desc: [%s] exceeds max length of [%s]',
  '1597': 'Soft Desc: Product Description cannot be present if Merchant Name is > %s',
  '1598':
    'Soft Desc: Product Description length cannot exceed [%s] if Merchant Name length is between %s and %s',
  '1599':
    'Soft Desc: Too many Merchant descriptors. Never send more than one of the following: City, phone, url OR email',
  '1600': 'Soft Desc: [%s] is not allowed for ECP transactions',
  '1601': 'Soft Desc: Invalid format for Merchant Phone. Must be nnn-nnn-aaaa or nnn-aaaaaaaa',
  '1602': 'Gateway is Down',
  '1603': 'Database Connection Problem: Cannot acquire Database Connection',
  '1604': 'Pcard 3 data was sent in parent split, but is missing in current request',
  '1605': 'If Alt Tax is sent Alt Tax ID is required',
  '1606': 'Three reasons could result in this error:',
  '1607': 'Line item count must be between 1 and 98 inclusive',
  '1608': 'Line item detail number [%s] is missing',
  '1609': 'Cannot send Pcard 3 data without sending Pcard 2 field',
  '1610': 'Minimal Pcard 3 base data missing or invalid',
  '1611': 'Minimal Pcard 3 line item data missing or invalid on index',
  '1612': 'Line Item Count does not match the number of line items sent',
  '1613': 'Invalid debit indicator for Bin 000002 in index. Must be D or C',
  '1614': 'Invalid Gross/Net for Bin 000002 in index. Must be Y or N',
  '1615': 'Amount hash error, negative total on line item data index',
  '1616': 'Amount hash error on line item data index. Total = [%s] Hash = [%s]',
  '1617': 'Detail totals do not match requested amount',
  '1618': 'Invalid Country Code',
  '1619': 'Invalid Unit of Measure in index',
  '1620':
    'Invalid [%s]:[%s]. The field is missing, invalid, or has exceeded the max length of: [%s].',
  '1621': 'Invalid Currency: [%s]. Currency Must Be Euro [978] or GB Pound Sterling [826].',
  '1622': 'The field is missing, invalid, or has exceeded the max length',
  '1623': 'The Bill Me Later Card Type [BL] is Not Allowed with this transaction.',
  '1624': 'Bill Me Later Generic Error Code',
  '1625': 'Invalid [Values. Must be one of the following values: XXX or empty',
  '1626': 'BML: Mandatory Field [Customer Birth Date] is missing for [New (N)] Customer Type',
  '1627': 'Unknown SOAP version',
  '1628': 'PINless Debit: Invalid. The field is missing, invalid, or has exceeded the max length.',
  '1629': 'PINless Debit: The PINless Debit Card Type [DP] is Not Allowed with [%s] Transactions.',
  '1630': 'PINless Debit: The PINless Debit Card Type [DP] is Only Allowed with [%s] Transactions',
  '1631':
    'PINless Debit: The PINless Debit Card Type [DP] must be sent with Industry Type of [%s].',
  '1632': 'PINless Debit: Card Number Not Eligible for PINless Debit Processing',
  '1633': 'Online reversals are not allowed for cardtype [x].',
  '1634':
    'Age of auth is [x] minutes, max age for online reversal of this method of payment is [x] minutes.',
  '1635':
    'Managed Billing features are not supported for Bill Me Later or Pinless Debit transaction types',
  '1636': 'Merchant account is not configured to use Managed Billing features',
  '1637':
    'Profile level for merchant account is set to ‘chain-level.’ In order to use Managed Billing, the profile level must be set to ‘merchant-level’',
  '1638': 'Invalid Order ID Generation Method. Use a valid value.',
  '1639': 'Invalid Managed Billing Type for merchant',
  '1640':
    'Deferred Billing Date must be a valid date (at least 1 day in the future – and at most 365 days in the future)',
  '1641': 'Recurring Start Date must be a valid date at least 1 day in the future',
  '1642': 'Only one Recurring End Date Trigger can be selected',
  '1643': 'Invalid Recurring No End Date flag. Must be ‘Y’ or ‘N’.',
  '1644': 'Invalid Max Number of Recurring Billings.',
  '1645':
    'Recurring End Date must be a valid date at least 1 day greater than Recurring Start Date',
  '1646': 'One of the 3 available Recurring Triggers must be set',
  '1647': 'Invalid Recurring Format',
  '1648':
    'Industry Type of ‘IN’ can only be used when merchant is configured for a Managed Billing type of Recurring',
  '1649': 'Missing Default Managed Billing values. All values must be set in transaction payload',
  '1650': 'Cancel Date must be a valid date',
  '1651': 'Daily Frequency Patterns are not accepted',
  '1652': 'Scheduling is not complete. Contact Gateway Support.',
  '1653': 'Profile is locked for update in progress',
  '1654':
    'Cancel or Restore Payment requests must be made separately from other Managed Billing Profile updates',
  '1655': 'Future payment date could not be found to cancel',
  '1656': 'Cancelled payment date could not be found to restore',
  '1657':
    'Start Date and End Date range is too small for selected recurring frequency (there are no possible future billings)',
  '1658': 'Existing deferred payment is already in progress',
  '1659': 'User does not have proper privileges to set-up a Managed Billing profile',
  '1660': 'Industry type of Recurring is not allowed to be set-up as Deferred Managed Billing type',
  '1661': 'Error occurred while searching for transaction related to retry trace ID',
  '1662': 'Failed to find transaction associated with retry trace ID',
  '1663': 'Error communicating with the host',
  '1664': 'Response timed out waiting for Authorization Host',
  '1665': 'Invalid Card Number',
  '1666': 'Invalid AVS ZIP Code',
  '1667':
    'Invalid Message Format. Transaction was flagged as an eCommerce Industry Type but No ECOrderNum was sent',
  '1668': 'The ECOrderNum or MailOrderNum was all Zero’s or All Spaces. These are not valid',
  '1669': 'Invalid Card Number',
  '1670': 'Transaction Amount to Large',
  '1671': 'Transaction Amount to Small',
  '1672':
    'Host eFalcon check requested from PNS [BIN 000002] – This functionality is not supported on this platform',
  '1673': 'Locked Down: Unable to Perform a Partial Void on Industry Type: [RE].',
  '1674': 'Either mcSecureCodeAAV or useStoredAAVInd [but not both] must be present',
  '1675': 'Static AAV is not on file for merchantID [%s]',
  '1676': 'Industry type must be one of [%s] for Card Brand [%s]',
  '1677': 'Managed Billing type must be [%s] for Account Type [%s]',
  '1678':
    'Static AAV must be on file for merchantID [%s] when Managed Billing type is [%s] and Account Type is [%s]',
  '1679': 'Invalid EUDD Country Code: [%s] for Currency: [%s], Valid values are: [%s]',
  '1680': 'User authentication failed. ',
  '1681':
    'Invalid tender type. Your merchant bank account does not support the following credit card type that was submitted.',
  '1682':
    'Invalid transaction type. Transaction type is not appropriate for this transaction. For example, you cannot credit an authorization-only transaction.',
  '1683':
    'Invalid amount format. Use the format: “#####.##”  Do not include currency symbols or commas. For processors that do not support Account Verification, you will receive this RESULT code if you process a $0 transaction.',
  '1684':
    'Invalid merchant information. Processor does not recognize your merchant account information. Contact your bank account acquirer to resolve this problem.',
  '1685': 'Invalid or unsupported currency code',
  '1686': 'Field format error. Invalid information entered. See RESPMSG.',
  '1687': 'Not a transaction server',
  '1688': 'Too many parameters or invalid stream',
  '1689': 'Too many line items',
  '1690': 'Client time-out waiting for response',
  '1691':
    'Declined. Check the credit card number, expiration date, and transaction information to make sure they were entered correctly. If this does not resolve the problem, have the customer call their card issuing bank to resolve.',
  '1692':
    'Referral. Transaction cannot be approved electronically but can be approved with a verbal authorization. Contact your merchant bank to obtain an authorization and submit a manual Voice Authorization transaction.  ',
  '1693':
    'Invalid Client Certification ID. Check the HTTP header. If the tag, X-VPS-VIT-CLIENT-CERTIFICATION-ID, is missing, RESULT code 14 is returned.',
  '1694':
    'Original transaction ID not found. The transaction ID you entered for this transaction is not valid. See RESPMSG.',
  '1695': 'Cannot find the customer reference number',
  '1696': 'Invalid ABA number',
  '1697': 'Invalid account number. Check credit card number and re-submit.',
  '1698': 'Invalid expiration date. Check and re-submit.',
  '1699':
    'Invalid Host Mapping. You are trying to process a tender type such as Discover Card, but you are not set up with your merchant bank to accept this card type.',
  '1700': 'Invalid vendor account',
  '1701': 'Insufficient partner permissions',
  '1702': 'Insufficient user permissions',
  '1703':
    'Invalid XML document. This could be caused by an unrecognized XML tag or a bad XML format that cannot be parsed by the system.',
  '1704': 'Duplicate transaction',
  '1705': 'Error in adding the recurring profile',
  '1706': 'Error in modifying the recurring profile',
  '1707': 'Error in canceling the recurring profile',
  '1708': 'Error in forcing the recurring profile',
  '1709': 'Error in reactivating the recurring profile',
  '1710': 'OLTP Transaction failed',
  '1711': 'Invalid recurring profile ID',
  '1712': 'Insufficient funds available in account',
  '1713': 'Exceeds per transaction limit',
  '1714': 'General error. See RESPMSG.',
  '1715': 'Transaction type not supported by host',
  '1716': 'Time-out value too small',
  '1717': 'Processor not available',
  '1718': 'Error reading response from host',
  '1719': 'Timeout waiting for processor response. Try your transaction again.',
  '1720':
    'Credit error. Make sure you have not already credited this transaction, or that this transaction ID is for a creditable transaction. (For example, you cannot credit an authorization.)',
  '1721': 'Host not available',
  '1722': 'Duplicate suppression time-out',
  '1723': 'Void error. ',
  '1724': 'Time-out waiting for host response',
  '1725': 'Referenced auth (against order) Error',
  '1726':
    'Capture error. Either an attempt to capture a transaction that is not an authorization transaction type, or an attempt to capture an authorization transaction that has already been captured.',
  '1727':
    'Failed AVS check. Address and ZIP code do not match. An authorization may still exist on the cardholder’s account.',
  '1728':
    'Merchant sale total will exceed the sales cap with current transaction. ACH transactions only.',
  '1729':
    'Card Security Code mismatch. An authorization may still exist on the cardholder’s account.',
  '1730': 'System busy, try again later',
  '1731': 'PayPal Internal error. Failed to lock terminal number',
  '1732': 'Failed merchant rule check. ',
  '1733': 'Invalid keywords found in string fields',
  '1734': 'General failure within PIM Adapter',
  '1735': 'Attempt to reference a failed transaction',
  '1736': 'Not enabled for feature',
  '1737':
    'Merchant sale total will exceed the credit cap with current transaction. ACH transactions only.',
  '1738': 'Fraud Protection Services Filter — Declined by filters',
  '1739': 'Fraud Protection Services Filter — Flagged for review by filters',
  '1740': 'Fraud Protection Services Filter — Not processed by filters',
  '1741':
    'Fraud Protection Services Filter — Declined by merchant after being flagged for review by filters',
  '1742':
    'Version 1 Payflow SDK client no longer supported. Upgrade to the most recent version of the Payflow client.',
  '1743': 'Card has not been submitted for update',
  '1744': 'Data mismatch in HTTP retry request',
  '1745': 'Issuing bank timed out',
  '1746': 'Issuing bank unavailable',
  '1747': 'Reauth error',
  '1748': 'Order error',
  '1749': 'PIM Adapter Unavailable',
  '1750': 'PIM Adapter stream error',
  '1751': 'PIM Adapter Timeout',
  '1752': 'Cybercash Batch Error',
  '1753': 'Cybercash Query Error',
  '1754':
    'Generic host error. This is a generic message returned by your credit card processor. The RESPMSG will contain more information describing the error.',
  '1755': 'Buyer Authentication unavailable',
  '1756': 'Buyer Authentication — Transaction timeout',
  '1757': 'Buyer Authentication — Invalid client version',
  '1758': 'Buyer Authentication — Invalid timeout value',
  '1759': 'Buyer Authentication unavailable',
  '1760': 'Buyer Authentication unavailable',
  '1761': 'Buyer Authentication unavailable',
  '1762':
    'Buyer Authentication — Merchant is not enrolled for Buyer Authentication Service (3-D Secure).',
  '1763':
    'Buyer Authentication — 3-D Secure error response received. Instead of receiving a PARes response to a Validate Authentication transaction, an error response was received.',
  '1764':
    'Buyer Authentication — 3-D Secure error response is invalid. An error response is received and the response is not well formed for a Validate Authentication transaction.',
  '1765': 'Buyer Authentication — Invalid card type',
  '1766': 'Buyer Authentication — Invalid or missing currency code',
  '1767': 'Buyer Authentication — merchant status for 3D secure is invalid',
  '1768': 'Buyer Authentication — Validate Authentication failed: missing or invalid PARES',
  '1769': 'Buyer Authentication — Validate Authentication failed: PARES format is invalid',
  '1770':
    'Buyer Authentication — Validate Authentication failed: Cannot find successful Verify Enrollment',
  '1771':
    'Buyer Authentication — Validate Authentication failed: Signature validation failed for PARES',
  '1772':
    'Buyer Authentication — Validate Authentication failed: Mismatched or invalid amount in PARES',
  '1773':
    'Buyer Authentication — Validate Authentication failed: Mismatched or invalid acquirer in PARES',
  '1774':
    'Buyer Authentication — Validate Authentication failed: Mismatched or invalid Merchant ID in PARES',
  '1775':
    'Buyer Authentication — Validate Authentication failed: Mismatched or invalid card number in PARES',
  '1776':
    'Buyer Authentication — Validate Authentication failed: Mismatched or invalid currency code in PARES',
  '1777':
    'Buyer Authentication — Validate Authentication failed: Mismatched or invalid XID in PARES',
  '1778':
    'Buyer Authentication — Validate Authentication failed: Mismatched or invalid order date in PARES',
  '1779':
    'Buyer Authentication — Validate Authentication failed: This PARES was already validated for a previous Validate Authentication transaction',
  '1780': 'No Answer',
  '1781': 'Approved',
  '1782': 'Validated',
  '1783': 'Verified',
  '1784': 'Pre-Noted',
  '1785': 'No Reason to Decline',
  '1786': 'Received and Stored',
  '1787': 'Provided Auth',
  '1788': 'Request Received',
  '1789': 'Approved for Activation',
  '1790': 'Previously Processed Transaction',
  '1791': 'BIN Alert',
  '1792': 'Approved for Partial',
  '1793': 'Conditional Approval',
  '1794': 'Invalid CC Number',
  '1795': 'Bad Amount Nonnumeric Amount',
  '1796': 'Zero Amount',
  '1797': 'Other Error',
  '1798': 'Bad Total Auth Amount',
  '1799': 'Invalid SKU Number',
  '1800': 'Invalid Credit Plan',
  '1801': 'Invalid Store Number',
  '1802': 'Invalid Field Data',
  '1803': 'Missing Companion Data',
  '1804': 'Percents do not total 100',
  '1805': 'Payments do not total 100',
  '1806': 'Invalid Division Number',
  '1807': 'Does not match MOP',
  '1808': 'Duplicate Order Number',
  '1809': 'FPO Locked',
  '1810': 'Auth Recycle Host System Down',
  '1811': 'FPO Not Approved',
  '1812': 'Invalid Currency',
  '1813': 'Invalid MOP for Division',
  '1814': 'Auth Amount for Division',
  '1815': 'Illegal Action',
  '1816': 'Invalid Purchase Level 3',
  '1817': 'Invalid Encryption Format',
  '1818': 'Missing or Invalid Secure Payment Data',
  '1819': 'Merchant not MasterCard Secure code Enabled',
  '1820': 'Check conversion Data Error',
  '1821': 'Blanks not passed in reserved field',
  '1822': 'Invalid (MCC)',
  '1823': 'Invalid Start Date',
  '1824': 'Invalid Issue Number',
  '1825': 'Invalid Tran. Type',
  '1826': 'Missing Cust Service Phone',
  '1827': 'Not Authorized to Send Record',
  '1828': 'Soft AVS',
  '1829': 'Account Not Eligible For Division’s Setup',
  '1830': 'Authorization Code Response Date Invalid',
  '1831': 'Partial Authorization Not Allowed or Partial Authorization Request Note Valid',
  '1832': 'Duplicate Deposit Transaction',
  '1833': 'Missing QHP Amount',
  '1834': 'Invalid QHP Amount',
  '1835': 'Transaction Not Supported',
  '1836': 'Issuer unavailable',
  '1837': 'Credit Floor',
  '1838': 'Processor Decline',
  '1839': 'Not On File',
  '1840': 'Already Reversed',
  '1841': 'Amount Mismatch',
  '1842': 'Authorization Not Found',
  '1843': 'TransArmor Service Unavailable',
  '1844': 'Expired Lock',
  '1845': 'TransArmor Invalid Token or PAN',
  '1846': 'TransArmor Invalid Result',
  '1847': 'Call',
  '1848': 'Default Call',
  '1849': 'Pickup',
  '1850': 'Lost/Stolen',
  '1851': 'Fraud/ Security Violation',
  '1852': 'Negative File',
  '1853': 'Excessive PIN try',
  '1854': 'Over the limit',
  '1855': 'Over Limit Frequency',
  '1856': 'On negative file',
  '1857': 'Insufficient funds',
  '1858': 'Card is expired',
  '1859': 'Altered Data',
  '1860': 'Do Not Honor',
  '1861': 'CVV2/VAK Failure',
  '1862': 'Do Not Honor - High Fraud',
  '1863': 'Stop payment order one time recurring/ installment',
  '1864': 'Revocation of Authorization for All Recurring / Installments',
  '1865': 'Revocation of All Authorizations – Closed Account',
  '1866': 'Account previously activated',
  '1867': 'Unable to void',
  '1868': 'Block activation failed',
  '1869': 'Block Activation Failed',
  '1870': 'Issuance Does Not Meet Minimum Amount',
  '1871': 'No Original Authorization Found',
  '1872': 'Outstanding Authorization, Funds on Hold',
  '1873': 'Activation Amount Incorrect',
  '1874': 'Block Activation Failed',
  '1875': 'CVD Value Failure',
  '1876': 'Maximum Redemption Limit Met',
  '1877': 'Invalid CC Number',
  '1878': 'Bad Amount',
  '1879': 'Other Error',
  '1880': 'New Card Issued',
  '1881': 'Suspected Fraud',
  '1882': 'Refund Not Allowed',
  '1883': 'Invalid Institution Code',
  '1884': 'Invalid Institution',
  '1885': 'Invalid Expiration Date',
  '1886': 'Invalid Transaction Type',
  '1887': 'Invalid Amount',
  '1888': 'BIN Block',
  '1889': 'FPO Accepted',
  '1890': 'Match Failed',
  '1891': 'Validation Failed',
  '1892': 'Invalid Transit Routing Number',
  '1893': 'Transit Routing Number Unknown',
  '1894': 'Missing Name',
  '1895': 'Invalid Account Type',
  '1896': 'Account Closed',
  '1897': 'Subscriber Number Does Not Exist',
  '1898': 'Subscriber Number Not Active',
  '1899': 'ACH Non-Participant',
  '1900': 'Duplicate Check',
  '1901': 'Original transaction was not approved',
  '1902': 'Rejected Code 3 (Risk)',
  '1903': 'Refund or partial amount is > original sale amount',
  '1904': 'Positive ID',
  '1905': 'Restraint',
  '1906': 'Invalid Security Code',
  '1907': 'Invalid PIN',
  '1908': 'No Account',
  '1909': 'Invalid Merchant',
  '1910': 'Unauthorized User',
  '1911': 'Process Unavailable',
  '1912': 'Invalid Expiration',
  '1913': 'Invalid Effective',
  '1914': 'Acquirer Error',
  '1921':
    'The credit card was accepted by the bank but refused by CyberSource because it did not.pass the AVS check. AVS result is N.',
  '1922': 'Indicates that you must call the issuing bank to proceed with the transaction.',
  '1923': 'CyberSource declined the request because the credit card has expired. ',
  '1924': 'The bank declined the transaction.',
  '1925':
    'The credit card was accepted by the bank but refused by CyberSource because it did not pass the CVN check. ',
  '1926': 'The credit card number did not pass CyberSource basic checks.',
  '1927': 'Data provided is not consistent with the request. ',
  '1928': 'The request is missing a required field.',
  '1929':
    'A request was made to capture or reverse an order for which there is no corresponding, unused authorization record. ',
  '1930':
    'The capture or credit is not voidable because the capture or credit information has already been submitted to your processor. Or, you requested a void for a type of transaction that cannot be voided.',
  '1931': 'System error.',
  '1932': 'The request timed out.',
  'EVO-0': 'UNKNOWN.',
  'EVO-1': 'AP. APPROVED OR COMPLETED SUCCESSFULLY. NGT Approved.',
  'EVO-2': 'CALL. REFER TO ISSUER (AMERICAN EXPRESS, DINERS, ETC.)',
  'EVO-3': 'CALL. TOUCHTONE CAPTURE, WONT ROLL TO AN OPERATOR.',
  'EVO-4': 'INVLD MERCH ID. INVALID MERCHANT ID.',
  'EVO-5': 'PIC UP. AUTHORIZATION DECLINED.',
  'EVO-6': 'DECLINE. AUTHORIZATION DECLINED.',
  'EVO-7': 'REVERSED. REQUESTED TRANSACTION REVERSAL WAS SUCCESSFUL. NGT Approved.',
  'EVO-8': 'DECLINE-CV2 FAIL. RESPONSE FOR CVV2 FAILURE. DECLINED. (VISA).',
  'EVO-9': 'APP WITH ID. APPROVED WITH POSITIVE ID. HOST DOES NOT CAPTURE THIS TRANSACTION.',
  'EVO-10': 'INVLD REQUEST. ADMINISTRATIVE MESSAGE CONTAINS A SYNTAX ERROR.',
  'EVO-11': 'INVLD AMOUNT. AMOUNT ENTERED IN INVALID.',
  'EVO-12': 'INVLD ACCT. ACCOUNT NUMBER DOES NOT PASS ISSUERS EDIT CHECKS.',
  'EVO-13': 'PLEASE RETRY. GATEWAY REQUESTS A RETRY.',
  'EVO-14': 'INVLD EXP DATE. EXPIRATION DATE ENTERED IS INCORRECT.',
  'EVO-15': 'PIN INVALID. INCORRECT PIN ENTERED.',
  'EVO-16': 'SERV NOT ALLOWED. MERCHANT NOT SET UP FOR TRANSACTION CODE USED.',
  'EVO-17': 'MAX PIN RETRIES. MAXIMUM PIN NUMBER ENTRY ATTEMPTS EXCEEDED.',
  'EVO-18': 'AP DUPE. TRANSACTION ENTERED IS A DUPLICATE.',
  'EVO-19': 'NETWORK UNAVAIL. SYSTEM UNAVAILABLE.',
  'EVO-20':
    'INV ACCT MATCH. THE ACCOUNT NUMBER ENTERED DURING A VOID OR ADJUSTMENT TRANSACTION DOES NOT MATCH THE ACCOUNT NUMBER STORED IN THE HOST FOR THAT ITEM.',
  'EVO-21':
    'INV AMT MATCH. THE AMOUNT ENTERED FOR A VOID OR ADJUSTMENT TRANSACTION DOES NOT MATCH THE AMOUNT STORED IN THE HOST FOR THAT ITEM.',
  'EVO-22':
    'INV ITEM NUM. THE ITEM NUMBER ENTERED FOR A VOID OR ADJUSTMENT TRANSACTION IS INCORRECT.',
  'EVO-23':
    'ITEM VOIDED. AN ADJUSTMENT OR ITEM REVIEW WAS ATTEMPTED ON A TRANSACTION PREVIOUSLY VOIDED OR REVERSED.',
  'EVO-24':
    'MUST BALANCE NOW. TERMINAL HAS NOT BEEN BALANCED WITHIN TIME SPECIFIED IN THE GLOBAL PAYMENTS MERCHANT MASTER FILE FOR THIS MERCHANT.',
  'EVO-25':
    'USE DUP THEN BALBEFORE BALANCING.. TERMINAL HAS NOT BEEN BALANCED WITHIN TIME SPECIFIED IN THE GLOBAL PAYMENTS MERCHANT MASTER FILE FOR THIS MERCHANT, BUT MERCHANT IS SET UP TO PERFORM EXTRA TRANSACTIONS BEFORE BALANCING.',
  'EVO-26': 'NO DUP FOUND. OVERRIDE TRANSACTION IS ATTEMPTED ON A NON-DUPLICATED TRANSACTION.',
  'EVO-27': 'INVALID DATA. FORMAT OF THE TRANSACTION IS INCORRECT.',
  'EVO-28':
    'NO TRANS FOUND. REVERSAL TRANSACTION IS ATTEMPTED ON A TRANSACTION THAT IS NOT IN THE OPEN BATCH ON THE HOST.',
  'EVO-29':
    'AP NOT CAPTURED. APPROVED BUT NOT CAPTURED (APPLIES ONLY TO CREDIT TRANSACTIONS). NGT Approved.',
  'EVO-30':
    'AP AUTH-ONLY. APPROVED BUT THIS EDC MERCHANT IS NOT SET UP TO CAPTURE THIS CARD TYPE (APPLIES ONLY TO CREDIT TRANSACTIONS). NGT Approved.',
  'EVO-31': 'INV BANK. ACQUIRING BANK ID ENTERED IS INCORRECT.',
  'EVO-32': 'TRAN TYPE INVLD. TRANSACTION NOT SUPPORTED BY EFT NETWORK OR CARD ISSUER.',
  'EVO-33': 'APPROVED. APPROVED DEBIT TRANSACTION. NGT Approved.',
  'EVO-34': 'DB UNAVAIL 02. GATEWAY IS DOWN.',
  'EVO-35': 'DB UNAVAIL 03. GATEWAY LINK TIMED OUT.',
  'EVO-36': 'DB UNAVAIL 04. GATEWAY CANNOT CONTACT EFT NETWORK OR EFT GROUP ID IS INCORRECT.',
  'EVO-37': 'UNAUTH USER. MERCHANT IS NOT SETUP FOR DEBIT ON MERCHANT MASTER FILE.',
  'EVO-38': 'INVALID CARD. DEBIT NOT ON ISSUER FILE.',
  'EVO-39': 'ISSUER UNAVAIL. EFT NETWORK CANNOT CONTACT ISSUER.',
  'EVO-40': 'INVALID POS CARD. CARD IS NOT ELIGIBLE FOR POS.',
  'EVO-41': 'ACCT TYPE INVLD. TYPE OF ACCOUNT ENTERED CANNOT BE ACCESSED (CHECKING, SAVINGS, ETC.)',
  'EVO-42': 'INVALID PREFIX. NO SHARING ARRANGEMENT FOR THIS CARD.',
  'EVO-43': 'INVALID FIID. GATEWAY FINANCIAL INSTITUTION ID NOT SET UP.',
  'EVO-44':
    'VERIFY XXXXXXXXX. MATCH ON SCAN FILE. XXXXXXXXX IS ROUTING/TRANSIT NUMBER ON THE NEGATIVE FILE.',
  'EVO-45':
    'INVALID LIC. THE LICENSE OR ID NUMBER ENTERED DURING A CHECK AUTHORIZATION TRANSACTION IS INCORRECT.',
  'EVO-46': 'EDC UNAVAILABLE. EDC APPLICATION DOWN, TRY LATER.',
  'EVO-47': 'DB UNAVAIL 01. DEBIT APPLICATION DOWN, TRY LATER.',
  'EVO-48': 'SCAN UNAVAILABLE. SCAN APPLICATION IS DOWN, TRY LATER. NGT Approved.',
  'EVO-49': 'EXCEEDS MAX AMT. EXCEEDS WITHDRAWAL AMOUNT LIMIT.',
  'EVO-50': 'EXCEEDS MAX USES. EXCEEDS WITHDRAWAL FREQUENCY LIMIT.',
  'EVO-51': 'OK. SUCCESSFUL SETTLEMENT - FINAL BLOCK. ',
  'EVO-52':
    'INV ACQ REF DATA. ACQUIRER REFERENCE DATA DID NOT PASS FIELD DEFINITION EDITS AS SPECIFIED IN THE FIELD DESCRIPTIONS.',
  'EVO-53': 'INVALID BATCH. MERCHANT IS MARKED AS INACTIVE ON EDC.',
  'EVO-54': 'INV BATCH NBR. INVALID BATCH NUMBER.',
  'EVO-55':
    'INV BAL/SETLDIFFERENCE. TOTALS IN POS DEVICE DO NOT MATCH HOST TOTALS AND THERE ARE NO REVERSALS, OR POS TOTALS DO NOT AGREE WITH HOST TOTALS AND THE REVERSALS CANNOT ACCOUNT FOR THE DIFFERENCE.',
  'EVO-56':
    'OK DB XXXX/XXXX. SETTLEMENT IS SUCCESSFUL, BUT THE AMOUNT AND ITEM COUNT DO NOT MATCH THE TOTALS IN THE HOST.',
  'EVO-57': 'INV REF NO. INVALID REFERENCE NUMBER.',
  'EVO-58': 'VOID ERROR.',
  'EVO-59': 'REC NOT FOUND. RECORD NOT FOUND.',
  'EVO-60': 'INV APP CODE. INVALID APPROVAL CODE.',
  'EVO-101': 'CARD NOT FOUND.',
  'EVO-102': 'CARD NOT ACTIVE.',
  'EVO-103': 'CARD EXPIRED. CARD EXPIRED.',
  'EVO-104': 'CAN NOT ACCEPT. CARD CAN NOT BE ACCEPTED BY THIS MERCHANT.',
  'EVO-105': 'ALREADY ACTIVE. CARD IS ALREADY ACTIVATED.',
  'EVO-106': 'NEGATIVE BAL. CARD NEGATIVE BALANCE.',
  'EVO-107': 'CANNOT VOID. CANNOT VOID TRANSACTION.',
  'EVO-108': 'ALREADY VOIDED. CARD TRANSACTION IS ALREADY VOIDED.',
  'EVO-109': 'INVALID AUTH NO. INVALID AUTH NUMBER FOR VOID TRANSACTION.',
  'EVO-110': 'NO AUTH NUMBER. NO AUTH NUMBER FOR VOID TRANSACTION.',
  'EVO-111': 'INCORRECT DATA. INVALID DATA FOR VOID TRANSACTION.',
  'EVO-112': 'SYSTEM ERROR.',
  'EVO-113': 'INVLD VOUCHER ID. INVALID VOUCHER ID.',
  'EVO-114': 'INVALID EST ID. INVALID ESTABLISHMENT ID (FCS OR SE).',
  'EVO-115': 'LOST CARD.',
  'EVO-116': 'INSUF FUNDS. INSUFFICIENT FUNDS.',
  'EVO-117': 'FRAUD RETURN CARD.',
  'EVO-118': 'VOUCHER EXPIRED.',
  'EVO-119': 'CARD DEACTIVATED.',
  'EVO-120': 'INVLD MER NAME. INVALID MERCHANT NAME.',
  'EVO-121': 'INVLD MER STREET. INVALID MERCHANT STREET ADDRESS.',
  'EVO-122': 'INVLD MER CITY. INVALID MERCHANT CITY.',
  'EVO-123': 'INVLD MER STATE. INVALID MERCHANT STATE.',
  'EVO-124': 'INVLD MER ZIP. INVALID MERCHANT ZIP CODE.',
  'EVO-125': 'INVLD MCC. INVALID MERCHANT CATEGORY CODE.',
  'EVO-126': 'REFERRED. FOR MANUAL APPROVAL. MERCHANT MUST CALL CUSTOMER SERVICE FOR APPROVAL.',
  'EVO-127': 'INVALID TERM ID. INVALID TERMINAL ID.',
  'EVO-128': 'INACTIV TERM ID. INACTIVE TERMINAL ID.',
  'EVO-129': 'INACTIV MER ID. NACTIVE MERCHANT ID.',
  'EVO-130': 'INACTIV DIV ID. INACTIVE DIVISION ID.',
  'EVO-131': 'INACTIV CLI ID. INACTIVE CLIENT ID.',
  'EVO-132': 'PIN PAD CONFIG. PIN PAD CONFIGURATION ERROR, SEE CRYPTOCONFIG SETUP.',
  'EVO-133': 'RESPONSE RESENT. TRANSACTION ENTERED IS A DUPLICATE. RESPONSE RESENT.',
  'EVO-134': 'BATCH IS CLOSED. BATCH IS ALREADY CLOSED.',
  'EVO-135': 'INVLD MER CFG. INVALID MERCHANT CONFIGURATION.',
};

export default PaymentErrors;
